import React from 'react'
import { Facebook, Twitter, Instagram } from "lucide-react";
import { useUser } from '../../context/useUser';

function NewsLetter(props) {
    const { country } = useUser()
    const { color } = props
    return (
        <div className={`bg-[${color}] mx-auto py-8 px-6 md:px-8 text-white`}>
            <div className="max-w-[1300px] mx-auto flex flex-col md:flex-row justify-between items-center">
                <div className="max-w-[350px]">
                    <h2 className="text-2xl font-semibold text-gray-900">Subscribe our Newsletter</h2>
                    <p className="text-gray-600 text-sm mt-2">
                        Stay updated! Subscribe to our newsletter for exclusive deals, fresh arrivals, and special offers.
                    </p>
                </div>
                <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-6 mt-4 md:mt-0">
                    <div className="flex rounded-full overflow-hidden">
                        <input
                            type="email"
                            placeholder="Your email address"
                            className="px-4 py-4 w-60 md:w-80 rounded-l-full  text-gray-600"
                            style={{ border: '1px solid #a8a8a8' }}
                        />
                        <button className={`${country === "PK" ? "bg-[#912c24]" : "bg-[#65754d]"} text-white px-6 py-2 text-sm font-semibold`}>
                            Subscribe
                        </button>
                    </div>
                    <div className="flex items-center gap-3">
                        <button className={`${country === "PK" ? "bg-[#912c24]" : "bg-[#65754d]"}  p-2 rounded-full text-white`}>
                            <Facebook size={16} fill="#ffffff" />
                        </button>
                        <Twitter className="text-gray-700" fill="#4d4d4d" size={20} />
                        <Instagram className="text-gray-700" size={20} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NewsLetter